import React from 'react'
// custom typefaces
import 'typeface-montserrat'
import 'typeface-merriweather'

import 'prismjs/themes/prism.css'

import { SearchContextProvider } from './src/components/SearchInput'

export const wrapRootElement = ({ element }) => (
    <SearchContextProvider>{element}</SearchContextProvider>
)
